import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  infoList: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  infoListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  infoListItemLabel: {
    marginBottom: theme.spacing(1),
  },
  infoListItemInfo: {
    marginBottom: theme.spacing(1),
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

/**
 * Lista de pares de informação. Cada par possui label e informação, sendo mostrados em duas colunas,
 * label na esquerda e informação na direita.
 */
const InfoList = ({ children, style, divider }) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.infoList} ${divider ? classes.divider : ""}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default InfoList;

export const InfoListItem = ({ label, info, infoTextColor = "textSecondary", bold, dividerListItem }) => {
  const classes = useStyles();
  return (
    <>
      <div className={`${classes.infoListItem} ${dividerListItem ? classes.divider : ""}`}>
        <Typography
          gutterBottom
          color="textSecondary"
          component="div"
          align="left"
          className={classes.infoListItemLabel}
        >
          {label}
        </Typography>
        <Typography
          gutterBottom
          color={infoTextColor}
          component="div"
          align="right"
          className={classes.infoListItemInfo}
          style={{ fontWeight: bold ? "bold" : "normal" }}
        >
          {info}
        </Typography>
      </div>
    </>
  );
};
